import { CO_CHAT_DETAILS } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { getCoChatChannelsDetails } from "../../api/cochat";
const initialState = {
  loading: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
  currentChannelId: "",
  cochatDetails: {} as any,
  isNotificationMuted: false,
  subscribedUsers: [] as any,
  chatMessages: [] as any,
  number: {} as any,
};
const coChatDetailsSlice = createSlice({
  name: CO_CHAT_DETAILS,
  initialState,
  reducers: {
    cochatDetails: (state, { payload }) => {
      state.cochatDetails = payload.cochatDetails;
    },
    enableMute: (state) => {
      state.isNotificationMuted = true;
    },
    disableMute: (state) => {
      state.isNotificationMuted = false;
    },
    subscribedUsersList: (state, { payload }) => {
      state.subscribedUsers = payload.subscribedUsers;
    },
    sendMessage: (state, { payload }) => {
      state.chatMessages.push(payload?.message);
    },
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(getCoChatChannelsDetails.pending, (state, _) => {
      state.loading = true;
    });
    builder.addCase(getCoChatChannelsDetails.fulfilled, (state, { payload }: any) => {
      if (payload?.data?.statusCode === 200) {
        const cochatDetails = payload.data?.result?.at(0);
        state.cochatDetails = cochatDetails;
        if (cochatDetails?.messages) {
          state.chatMessages = JSON.parse(cochatDetails?.messages) ?? [];
        }
      } else {
        state.cochatDetails = {};
        state.chatMessages = [];
      }
      state.loading = false;
    });
    builder.addCase(getCoChatChannelsDetails.rejected, (state, _) => {
      state.loading = false;
    });
  },
});
export const cochatDetailsActions = coChatDetailsSlice.actions;
export default coChatDetailsSlice.reducer;
